module.exports = __webpack_public_path__ + "static/media/microeconomics-completed.97444742.svg";